import { render, staticRenderFns } from "./TasksCategorical.vue?vue&type=template&id=075fe574"
import script from "./TasksCategorical.vue?vue&type=script&lang=js"
export * from "./TasksCategorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports